import { http } from '@/api/http';
import type { OrganizationContent } from '@/features/aboutOrganization/types';

export type OrganizationContentMutationInput = OrganizationContent;

export const fetchOrganizationContent = async (): Promise<OrganizationContent> => {
  return http.get<OrganizationContent>('/api/v1/organization');
};

export const fetchAdminOrganizationContent = async (): Promise<OrganizationContent> => {
  return http.get<OrganizationContent>('/api/v1/admin/organization');
};

export const updateOrganizationContent = async (
  input: OrganizationContentMutationInput,
): Promise<OrganizationContent> => {
  return http.put('/api/v1/admin/organization', input);
};
